import type { PortfolioItem } from "../store/types";

const NOW = "2026-03-24T00:00:00Z";

export const MOCK_PORTFOLIO_ITEMS: PortfolioItem[] = [
  {
    id: "pf-001",
    title: "Photographer with Film Camera",
    city: "kyoto",
    shoot_type: "portrait",
    media_type: "image",
    thumbnail_url:
      "https://public.readdy.ai/ai/img_res/bcdc09b5372974d07493837c418855f3.jpg",
    media_url:
      "https://readdy.ai/api/search-image?query=photographer%20adjusting%20vintage%20film%20camera%20soft%20natural%20window%20light%20Japan%20studio%20warm%20tones%20bokeh%20minimal%20aesthetic%20candid%20editorial&width=560&height=360&seq=story-img-1&orientation=landscape",
    cover_image_url:
      "https://readdy.ai/api/search-image?query=photographer%20adjusting%20vintage%20film%20camera%20soft%20natural%20window%20light%20Japan%20studio%20warm%20tones%20bokeh%20minimal%20aesthetic%20candid%20editorial&width=560&height=360&seq=story-img-1&orientation=landscape",
    description_zh: "每一次快門，都是一段故事的開始。",
    description_en: "Every click of the shutter is where a story begins.",
    description_ja: "シャッターが切られるたびに、物語が始まる。",
    photographer_id: "ph-kenji",
    is_published: true,
    is_featured: true,
    is_showreel: true,
    homepage_display_mode: "both",
    sort_order: 1,
    created_at: NOW,
    updated_at: NOW,
  },
  {
    id: "pf-002",
    title: "Candid Laughter in Kyoto",
    city: "kyoto",
    shoot_type: "couple",
    media_type: "image",
    thumbnail_url:
      "https://readdy.ai/api/search-image?query=Japanese%20couple%20laughing%20candid%20moment%20Kyoto%20street%20cherry%20blossom%20soft%20backlight%20film%20grain%20warm%20tones%20authentic%20emotional%20photography&width=560&height=360&seq=story-img-2&orientation=landscape",
    media_url:
      "https://readdy.ai/api/search-image?query=Japanese%20couple%20laughing%20candid%20moment%20Kyoto%20street%20cherry%20blossom%20soft%20backlight%20film%20grain%20warm%20tones%20authentic%20emotional%20photography&width=560&height=360&seq=story-img-2&orientation=landscape",
    cover_image_url:
      "https://readdy.ai/api/search-image?query=Japanese%20couple%20laughing%20candid%20moment%20Kyoto%20street%20cherry%20blossom%20soft%20backlight%20film%20grain%20warm%20tones%20authentic%20emotional%20photography&width=560&height=360&seq=story-img-2&orientation=landscape",
    description_zh: "真實的歡笑，永遠是最美的照片。",
    description_en: "Genuine laughter is always the most beautiful photograph.",
    description_ja: "本物の笑いは、いつでも最も美しい写真だ。",
    photographer_id: "ph-saki",
    is_published: true,
    is_featured: true,
    is_showreel: true,
    homepage_display_mode: "both",
    sort_order: 2,
    created_at: NOW,
    updated_at: NOW,
  },
  {
    id: "pf-003",
    title: "The Texture of Film",
    city: "kyoto",
    shoot_type: "detail",
    media_type: "image",
    thumbnail_url:
      "https://readdy.ai/api/search-image?query=hands%20holding%20vintage%20film%20camera%20detail%20shot%20bokeh%20soft%20light%20emotional%20photography%20memory%20Japan%20minimal%20clean%20background&width=560&height=360&seq=story-img-3&orientation=landscape",
    media_url:
      "https://readdy.ai/api/search-image?query=hands%20holding%20vintage%20film%20camera%20detail%20shot%20bokeh%20soft%20light%20emotional%20photography%20memory%20Japan%20minimal%20clean%20background&width=560&height=360&seq=story-img-3&orientation=landscape",
    cover_image_url:
      "https://readdy.ai/api/search-image?query=hands%20holding%20vintage%20film%20camera%20detail%20shot%20bokeh%20soft%20light%20emotional%20photography%20memory%20Japan%20minimal%20clean%20background&width=560&height=360&seq=story-img-3&orientation=landscape",
    description_zh: "用底片留住時光，每一張都是獨一無二的記憶。",
    description_en: "Film captures light the way memory captures feeling.",
    description_ja: "フィルムは感情が記憶を捉えるように、光を捉える。",
    photographer_id: "ph-haruto",
    is_published: true,
    is_featured: true,
    is_showreel: true,
    homepage_display_mode: "both",
    sort_order: 3,
    created_at: NOW,
    updated_at: NOW,
  },
  {
    id: "pf-004",
    title: "Dusk on Osaka Bridge",
    city: "osaka",
    shoot_type: "couple",
    media_type: "image",
    thumbnail_url:
      "https://readdy.ai/api/search-image?query=couple%20on%20bridge%20at%20sunset%20Osaka%20Japan%20warm%20golden%20hour%20soft%20backlight%20film%20grain%20cinematic%20emotional%20romantic%20urban%20photography%20bokeh&width=560&height=360&seq=pf-osaka-bridge&orientation=landscape",
    media_url:
      "https://readdy.ai/api/search-image?query=couple%20on%20bridge%20at%20sunset%20Osaka%20Japan%20warm%20golden%20hour%20soft%20backlight%20film%20grain%20cinematic%20emotional%20romantic%20urban%20photography%20bokeh&width=560&height=360&seq=pf-osaka-bridge&orientation=landscape",
    cover_image_url:
      "https://readdy.ai/api/search-image?query=couple%20on%20bridge%20at%20sunset%20Osaka%20Japan%20warm%20golden%20hour%20soft%20backlight%20film%20grain%20cinematic%20emotional%20romantic%20urban%20photography%20bokeh&width=560&height=360&seq=pf-osaka-bridge&orientation=landscape",
    description_zh: "夕陽下的兩人，是最動人的風景。",
    description_en: "Two people at dusk — the most moving landscape of all.",
    description_ja: "夕暮れの二人——最も心を動かす風景。",
    photographer_id: "ph-yuki",
    is_published: true,
    is_featured: false,
    is_showreel: false,
    homepage_display_mode: "still",
    sort_order: 4,
    created_at: NOW,
    updated_at: NOW,
  },
  {
    id: "pf-005",
    title: "Silent Shrine Path",
    city: "kyoto",
    shoot_type: "landscape",
    media_type: "image",
    thumbnail_url:
      "https://readdy.ai/api/search-image?query=person%20walking%20through%20torii%20gates%20shrine%20path%20Japan%20misty%20morning%20soft%20light%20atmospheric%20cinematic%20film%20grain%20low%20saturation%20peaceful%20solitude%20photography&width=560&height=360&seq=pf-shrine-path&orientation=landscape",
    media_url:
      "https://readdy.ai/api/search-image?query=person%20walking%20through%20torii%20gates%20shrine%20path%20Japan%20misty%20morning%20soft%20light%20atmospheric%20cinematic%20film%20grain%20low%20saturation%20peaceful%20solitude%20photography&width=560&height=360&seq=pf-shrine-path&orientation=landscape",
    cover_image_url:
      "https://readdy.ai/api/search-image?query=person%20walking%20through%20torii%20gates%20shrine%20path%20Japan%20misty%20morning%20soft%20light%20atmospheric%20cinematic%20film%20grain%20low%20saturation%20peaceful%20solitude%20photography&width=560&height=360&seq=pf-shrine-path&orientation=landscape",
    description_zh: "走在神社的石板路上，時間似乎放慢了腳步。",
    description_en: "Walking the stone path of a shrine, time seems to slow.",
    description_ja: "神社の石畳を歩くとき、時間が緩やかになる。",
    photographer_id: "ph-akira",
    is_published: true,
    is_featured: false,
    is_showreel: false,
    homepage_display_mode: "still",
    sort_order: 5,
    created_at: NOW,
    updated_at: NOW,
  },
];
